<template>
    <div>
        <h1>Backend using Java8+ and Spring Boot</h1>
        <p>Congrats! Backend using Java is a great stack!</p>

        <BackendTechReq></BackendTechReq>

        <h3>Java-specific requirements</h3>
        <ul>
            <li>Use <i>Spring Boot</i></li>
            <li>Use <i>Maven</i> <span class="comment">/* have a .pom and do <i>mvn clean install */</i></span></li>
            <li>Use <a href="https://junit.org/junit5/">JUnit</a> for unit tests</li>
            <li>Use a <i>@RestController</i></li>
            <li>Have a <i>@Service</i> which is <i>@Autowired</i> into the <i>@RestController</i> </li>
            <li>Delegate all the business logic to the <i>@Service</i> </li>
            <li>Each endpoint should have the correct <i>@GetMapping</i> / <i>@PostMapping</i> etc, and return relevant HTTP status codes for success / error. </li>
            <li>The state shall be persisted using <i>JPA</i></li>
            <li>Have unit tests that tests your <i>@Service</i>, and that runs as a part of the Maven build. </li>
            <li>Use <i>Streams</i> instead of loops</li>
        </ul>
        <br />
        <h3>This should get you started</h3>
        <CodeBox><pre>@RestController
public class MyController {
        @Autowired
        private Service service;

        @GetMapping("/ping")
        public String ping() {
                return "pong";
        }
        // Implement some more
}</pre></CodeBox>

        <BackendNav></BackendNav>
    </div>
</template>

<script>
import BackendTechReq from '@/components/BackendTechReq.vue'
import CodeBox from '@/components/CodeBox.vue'
import BackendNav from '@/components/BackendNav.vue'

export default {
    name: 'BackendJava',
    components: {
        BackendTechReq,
        CodeBox,
        BackendNav
    }
}
</script>

